import React, {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import "../../assets/css/adminPages/home/notices.scss";
import "../../assets/css/pages/allNotices/style.scss";
import DataLoader from "../../components/loader/dataLoader";
import DynamicPagination from "../../components/pagination/dynamicPagination";
import config from "../../config/apiService.json";
import fetchData from "../../utils/fetchData";
import {fileTypePdfOrNot} from "../../utils/fileTypeValidityCheckService";
import {
  deleteMethod,
  patchMethod,
  postMethod,
} from "../../utils/httpServices";
import AllNoticesTable from "./components/allNoticesTable";
import TableDataSizePerPage from "./components/tableDataSizePerPage";

const Index = () => {
  const [data, setData] = useState();
  const [showLoader, setShowLoader] = useState(true);
  const [showDataPerPage, setShowDataPerPage] = useState(5);
  const {notices: noticesApiEndPoint, administrative} = config;
  const [total, setTotal] = useState();
  const [activePage, setActivePage] = useState(1);
  const [pdfFile, setPdfFile] = useState(null);
  const [demoObj, setDemoObj] = useState({titleEn: "", file: ""});
  const [modalPdfFile, setModalPdfFile] = useState(null);
  const modalCloseIconButton = useRef();
  const pdfUploaderRef = useRef(null);

  const noticeTxtMaxLength = 400;

  const getData = async () => {
    const result = await fetchData(
        `${noticesApiEndPoint}?currentPage=${
            activePage - 1
        }&recordPerPage=${showDataPerPage}`
    );
    const {total, notices} = result;
    setTotal(total);
    setData(notices);
  };

  useEffect(() => {
    setShowLoader(true);
    getData();
    setShowLoader(false);
  }, []);

  useEffect(() => {
    setShowLoader(true);
    getData();
    setShowLoader(false);
  }, [showDataPerPage, activePage]);

  const handlePaginate = (clickedPaginatePageNumber) => {
    setActivePage(clickedPaginatePageNumber);
  };

  const handleTableDataSizePerPageSelectChange = (e) => {
    const pageSize = e.target.value;
    setActivePage(1);
    setShowDataPerPage(pageSize);
  };

  const handleNoticeChange = (e, id) => {
    const modifiedData = data.map((d) => {
      if (d.id === id) {
        d.titleEn = e.target.value;
        e.target.value.length >= noticeTxtMaxLength &&
        toast.warning(`Maximum ${noticeTxtMaxLength} Characters!`);
      }
      return d;
    });
    setData(modifiedData);
  };

  const hanldePdfFileUpload = async (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        const modifiedData = data.map((d) => {
          if (d.id === id) {
            d.fileTag = file.name;
          }
          return d;
        });
        setData(modifiedData);
        setPdfFile(file);
      }
    }
  };

  const handleUpdate = async (id) => {
    let updatedData = data.filter((d) => d.id === id);
    updatedData = updatedData[0];

    if (updatedData.titleEn.trim() !== "") {
      const formData = new FormData();
      pdfFile && formData.append("file", pdfFile);
      formData.append("titleEn", updatedData.titleEn);

      try {
        const response = await patchMethod(
            `${administrative.home.notices}/${id}`,
            formData
        );
        if (response) {
          toast.success("Notice Updated!");
          setPdfFile(null);
          getData();
        }
      } catch (ex) {
        toast.error(ex.response.data);
      }
    } else toast.error("Invalid Notice Description.");


  };

  const handleDelete = async (id) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#354e80",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteMethod(
              `${administrative.home.notices}/${id}`
          );
          if (response) {
            let updatedData = data.filter((d) => d.id != id);
            setData(updatedData);
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
          }
        }
      });
    } catch (ex) {
      toast.error(ex.response.data);
    }
  };

  // Add Notice
  const handleModalTittleChange = (e) => {
    setDemoObj({
      ...demoObj,
      titleEn: e.target.value,
    });
  };

  const handleModalFileUpload = (e) => {
    let file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        setModalPdfFile(file);
        setDemoObj({
          ...demoObj,
          file: file.name,
        });
      }
    }
  };

  const handleAdd = async () => {
    try {
      const formData = new FormData();
      modalPdfFile && formData.append("file", modalPdfFile);
      formData.append("titleEn", demoObj.titleEn);

      const response = await postMethod(
          `${administrative.home.notices}`,
          formData
      );
      if (response) {
        toast.success("Notice Added!");
        let updatedData = data;
        updatedData = [response, ...updatedData];
        setData(updatedData);
        setDemoObj({titleEn: "", file: ""});
        pdfUploaderRef.current.value = "";
        modalCloseIconButton.current.click();
        setModalPdfFile(null);
      }
    } catch (ex) {
      toast.error(ex.response.data);
    }
  };

  return (
      <section className="notices notices-update-section">
        <div className="custom-container">
          <div className="content-section">
            <h1 className="page-title">e-Notice board</h1>
            <div className="content-body">
              <div className="pb-5 pb-lg-4 px-4 text-right">
                <button
                    type="button"
                    className="add-btn"
                    data-toggle="modal"
                    data-target="#staticBackdrop"
                >
                  Add Notice +
                </button>
                <div
                    className="modal fade"
                    id="staticBackdrop"
                    data-backdrop="static"
                    data-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Add Notices
                        </h5>
                        <button
                            ref={modalCloseIconButton}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="custom-act-rules-order-card mx-auto">
                          <div className="card-body d-block text-left">
                            <div className="form__div-container w-100 mb-0">
                              <div className="form__div">
                                <input
                                    required
                                    type="text"
                                    name="titleEn"
                                    id="titleEn"
                                    className="form__input"
                                    placeholder=" "
                                    onChange={handleModalTittleChange}
                                    value={demoObj.titleEn}
                                    maxLength={noticeTxtMaxLength}
                                />
                                <label htmlFor="" className="form__label">
                                  Notice
                                </label>
                              </div>
                            </div>
                            <div className="form__div-container w-100 my-3">
                              <div className="d-flex align-items-center">
                                <label htmlFor="pdfUploader">
                                  <i
                                      className="fa fa-cloud-upload fa-2x clickable"
                                      style={{color: "rgba(53, 78, 128, 0.9)"}}
                                  ></i>
                                </label>
                                <input
                                    ref={pdfUploaderRef}
                                    onChange={handleModalFileUpload}
                                    id="pdfUploader"
                                    type="file"
                                    className="d-none"
                                    accept="application/pdf"
                                />
                                <p
                                    title={demoObj.file}
                                    className="ml-2 mb-1 one-line-overflow-ellepse"
                                >
                                  {demoObj.file}
                                </p>
                              </div>
                            </div>
                            <button
                                type="button"
                                onClick={handleAdd}
                                className="save-btn btn-block"
                            >
                              add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showLoader && <DataLoader/>}
              {data && total && (
                  <>
                    <TableDataSizePerPage
                        onChange={handleTableDataSizePerPageSelectChange}
                    />
                    <AllNoticesTable
                        notices={data}
                        activePage={activePage}
                        pageSize={showDataPerPage}
                        handleNoticeChange={handleNoticeChange}
                        hanldePdfFileUpload={hanldePdfFileUpload}
                        handleUpdate={handleUpdate}
                        handleDelete={handleDelete}
                        noticeTxtMaxLength={noticeTxtMaxLength}
                    />
                    <DynamicPagination
                        activePage={activePage}
                        itemsPerPage={showDataPerPage}
                        totalItems={total}
                        handlePaginateButtonClick={handlePaginate}
                    />
                  </>
              )}
            </div>
          </div>
        </div>
      </section>
  );
};

export default Index;
